// extracted by mini-css-extract-plugin
module.exports = {"time":"time-1xI01","mobile":"mobile-1ddMK","point_thin":"point_thin-3kael","airport":"airport-30fcq"};